/** IBAN normalisé : majuscules, sans espaces ni caractères hors [A-Z0-9]. */
export const normalizeIban = (value?: string | null): string =>
  (value ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '');

/** Affichage par groupes de 4 caractères (« FR76 3000 1007 … »). */
export const formatIban = (value?: string | null): string =>
  normalizeIban(value).replace(/(.{4})/g, '$1 ').trim();

const IBAN_LENGTHS: Record<string, number> = {
  FR: 27, MC: 27, DE: 22, BE: 16, ES: 24, IT: 27, LU: 20, NL: 18, PT: 25, CH: 21, GB: 22, IE: 22, AT: 20
};

/** Clé de contrôle ISO 7064 mod 97-10 : reste 1 après déplacement des 4 premiers caractères et conversion A=10…Z=35. */
export const hasValidIbanChecksum = (value: string): boolean => {
  const iban = normalizeIban(value);
  if (iban.length < 5) return false;
  const rearranged = iban.slice(4) + iban.slice(0, 4);
  let remainder = 0;
  for (const char of rearranged) {
    const digits = char >= 'A' ? String(char.charCodeAt(0) - 55) : char;
    for (const digit of digits) remainder = (remainder * 10 + Number(digit)) % 97;
  }
  return remainder === 1;
};

/** Longueur (15–34, ou la longueur exacte du pays connu), format et clé de contrôle. */
export const isValidIban = (value?: string | null): boolean => {
  const iban = normalizeIban(value);
  if (!/^[A-Z]{2}\d{2}[A-Z0-9]+$/.test(iban)) return false;
  const expected = IBAN_LENGTHS[iban.slice(0, 2)];
  if (expected ? iban.length !== expected : iban.length < 15 || iban.length > 34) return false;
  return hasValidIbanChecksum(iban);
};

export const IBAN_INVALID_MESSAGE = 'IBAN invalide (vérifiez la longueur et la clé de contrôle)';
